import { PercentMetricChart } from '../../../renderers/percent-metric-chart/percent-metric-chart.component';
import { ChartRendererProps } from '../../../types/chart-renderer-props';
import { IOTS_UPTIME_METRIC_CHART_DEFINITION } from './iots-uptime-metric-chart.definition';
import { IOTS_UPTIME_METRIC_CHART_MOCK_DATA } from './iots-uptime-metric-chart.mock';

export const IotsUptimeMetricChart = (props: ChartRendererProps) => <PercentMetricChart {...props} />;

IotsUptimeMetricChart.definition = IOTS_UPTIME_METRIC_CHART_DEFINITION;
IotsUptimeMetricChart.mockData = IOTS_UPTIME_METRIC_CHART_MOCK_DATA;
